import styled, { css } from "styled-components";
import { ACSS } from "@upsolve/ui";
import { BreadCrumbCSS } from "./BreadcrumbNav";

const Article = styled.main.attrs((props) => ({
  id: "article",
}))`
  width: 100%;
  max-width: 1140px;
  padding-left: 35px;
  margin: 4em auto 2em;
  display: flex;
  flex-direction: column;
  overflow: visible;

  @media (max-width: ${(props) => props.theme.breakpoints[750]}) {
    padding-left: 0;
    max-width: calc(100vw - 35px);
  }
  @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
    padding-left: 0;
    margin: 1em auto;
    max-width: 100%;
  }

  .article__breadcrumb {
    ${BreadCrumbCSS}
  }

  .article__content {
    word-break: break-word;

    @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
      width: 100%;
    }

    div.cover-image {
      height: 300px;
      width: 100%;
      margin: 0 auto 2em;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .content-hero {
      display: flex;
      flex-direction: row;
      align-items: space-between;
      margin: 0 0 1em;
      //width: calc(100% + 4em);
      @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
        margin: 0;
        width: 100%;
      }
      @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
        flex-direction: column;
        align-items: initial;
      }
    }
    .content-hero__header {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      ol,
      ul {
        padding: 0;
        margin: 0.5em 0;
      }
      label {
        margin-right: 0.5em;
      }
      h1 {
        background: ${(props) => props.theme.colors.white[900]};
        color: ${(props) => props.theme.colors.gray[400]};
        padding: 0.25em 1em 0.25em 0.25em;
        margin: 0 -0.25em;
      }
    }

    .content-author {
      display: flex;
      align-items: center;
      background: ${(props) => props.theme.colors.white["900"]};
      padding: 0.1em 0.5em;
      margin: -0.1em -0.5em;
      & > div {
        margin: 1.25em 0;
      }
      .author-image,
      img {
        height: 48px;
        width: 48px;
        min-height: 48px;
        min-width: 48px;
        border-radius: 36px;
      }
      & > p {
        margin: 1em 0.75em;
        font-size: 14px;
      }
      small {
        color: ${(props) => props.theme.colors.gray["900"]};
      }
      &__images {
        display: flex;
        padding-right: 4px;
        & > * {
          margin: 0 -4px;
        }
      }
    }
    .content-insert {
      a {
        ${ACSS}
      }
    }

    .content-video {
      max-width: 100%;
      height: 360px;
      margin: 0 auto;
      padding: 1em 0;
      @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
        width: 540px;
        height: 270px;
      }
    }

    .content-body {
      display: flex;
      flex-wrap: wrap;
      float: left;
      padding: 0;
      margin-top: 0.5em;

      @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
        padding-top: 0;
        margin-top: 0;
      }

      section,
      div.section {
        display: block;
        padding-bottom: 1em;
        margin-bottom: 1.5em;
        border-bottom: 1px solid ${(props) => props.theme.colors.white["500"]};
        &:first-of-type {
          & > *:first-of-type {
            margin-top: 0;
          }
        }
        &:last-of-type {
          border-bottom: none;
        }
        p {
          img {
            min-height: 240px;
            min-width: 240px;
            height: auto;
            width: auto;
            max-height: 400px;
            max-width: 100%;
            display: block;
            margin: 0 auto;
          }
        }
        & > img {
          max-height: 360px;
          margin: 0 auto;
          max-width: 100%;
        }
        div.image-caption {
          width: 100%;
          text-align: center;
          small {
            color: ${(props) => props.theme.colors.gray[900]};
          }
        }
        @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
          padding-bottom: 1.5em;
          margin-bottom: 1.5em;
        }
      }
      img {
        max-width: 100%;
      }
      @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
        padding: 1em 0;
        width: 100%;
      }
    }

    .content-body__container {
      width: 66%;
      @media (max-width: ${(props) => props.theme.breakpoints[750]}) {
        width: 75%;
        margin: 0 auto;

        // Style the mobile sidebar when inside container
        .article__sidebar {
          width: 100%;
          margin: 1em 0;
          display: flex;
          flex-direction: column;
          align-items: center;

          .sidebar-hero__cta {
            padding-left: 0;
            position: static;
            margin-bottom: 2em;
          }
        }
      }
      @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
        width: 100%;
      }
    }

    .content-body__lead {
      width: 100%;
      & > div,
      & > section,
      & > div.section {
        width: 100%;
      }
      .summary {
        padding: 24px;
        margin: 0 auto 0.5em;
        border-radius: 16px;
        background: var(--brand-800, #ebefff);
        display: flex;
        flex-direction: column;
        gap: 17px;
        b {
          color: #3c5dff;
          /* Accent/Bold */
          font-size: 12px;
          font-style: normal;
          font-weight: 700;
          line-height: 150%; /* 18px */
          text-transform: uppercase;
        }
        p {
          color: #000;
          line-height: 170%; /* 27.2px */
          margin: 0;
        }
      }
    }

    .content-body__nav {
      list-style-type: disc;
      color: ${(props) => props.theme.colors.white["300"]};
      li {
        margin-left: 0;
        padding-left: 0;
        & > a {
          color: ${(props) => props.theme.colors.brand["500"]};
        }
      }
    }

    .author-bios {
      margin-bottom: 2em;
      .written-by {
        width: 100%;
        margin: 0.5em 0 0.25em;
        text-align: center;
        small {
          color: ${(props) => props.theme.colors.gray[700]};
          font-weight: 500;
        }
      }
      .team {
        text-align: center;
        background: ${(props) => props.theme.colors.white[800]};
        padding: 0.75em 1em;
        box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.1);
        &,
        a {
          ${ACSS}
          font-weight: 500;
          font-size: 13px;
        }
      }
    }

    ul {
      list-style-type: disc;
    }
    ul,
    ol {
      padding: 0 1em;
    }
    li {
      margin: 0 0.25em 0.5em;
      & > p {
        margin: 0;
      }
    }
    hr {
      margin: 1em 0;
      border: 1px solid ${(props) => props.theme.colors.white[700]};
    }
    h1 {
      margin: 0;
    }
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 0.5em 0 0.25em;
      line-height: 125%;
    }
    iframe {
      border: none;
      outline: none;
      max-width: 100%;
      margin: 0 auto;
    }
    p,
    li {
      a {
        ${ACSS}
      }
    }
    table {
      margin: 0.75em 0;
    }
  }

  .related-content {
    & > div,
    section {
      margin: 1em 0;
    }
    @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
      margin: 1em 1.5em;
    }
  }

  aside {
    float: right;
    width: 33%;
    color: ${(props) => props.theme.colors.gray["500"]};
    .sidebar-hero__cta {
      width: 100%;
      position: sticky;
      top: 5em;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
      @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
        margin-left: 0;
      }
    }
    h5 {
      border-bottom: 1px solid ${(props) => props.theme.colors.white["500"]};
    }
    & > div,
    & > section,
    & > div.section {
      display: flex;
      flex-direction: column;
      margin-bottom: 2em;
    }
    p,
    li > a {
      font-size: 14px;
    }
    p > a {
      ${ACSS}
    }
    ul {
      margin-top: 1em;
      list-style: disc;
      color: ${(props) => props.theme.colors.white["500"]};
      li {
        margin-left: 1em;
        margin-bottom: 0.1em;
        & > a {
          color: ${(props) => props.theme.colors.brand["500"]};
        }
      }
    }

    // Mobile/Desktop specific modifications
    &.mobile-only {
      display: none;
      @media (max-width: ${(props) => props.theme.breakpoints[750]}) {
        display: block;
        width: 100%;
        float: none;
        margin: 1em 0;

        .sidebar-hero__cta {
          width: 100%;
          padding-left: 0;
          position: relative;
          margin-bottom: 2em;
        }
      }
    }

    &.desktop-only {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-left: 1.5em;
      @media (max-width: ${(props) => props.theme.breakpoints[750]}) {
        display: none;
      }
    }

    // Sidebar (really just the CTA)
    @media (max-width: ${(props) => props.theme.breakpoints[750]}) {
      width: 100%;
      .sidebar-hero__cta {
        padding-left: 0;
      }
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
    .article__breadcrumb {
      margin: 0 1.5em;
      ol {
        margin: 0;
        font-size: 14px;
      }
    }
    .article__body {
      display: flex;
      flex-wrap: wrap;
      margin: 1em 1.25em;
    }
  }

  // Extra Type Options
  ${(props) => {
    if (props.styleType === "centered") {
      return css`
        padding-left: 0;
        nav ol {
          justify-content: center;
        }
        .article__content .content-hero__header > h1 {
          padding: 0.25em 1em;
          margin: 0;
          text-align: center;
        }
        .content-body__container {
          margin: 0 auto;
        }
      `;
    }
  }}

  .mobile-cta-wrapper {
    width: 100%;
    clear: both;
    overflow: hidden;
    margin: 1em 0;
  }
`;

export default Article;
